<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button size="mini" type="primary" @click="_create"
          >新增</el-button
        >
        <el-button size="mini" type="success" plain @click="onExport"
          >导出</el-button
        >
        <el-button
          size="mini"
          type="success"
          plain
          @click="onImport"
          icon="el-icon-plus"
          >导入</el-button
        >
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template slot-scope="{ row }">
            <el-button type="text" @click="_edit(row)">查看</el-button>
            <el-button type="text" @click="generatePurchaseOrder(row)" :disabled="row.Status === 1">生成采购</el-button>
            <el-button type="text" @click="del(row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <import-dialog ref="importDialog" @upload-success="reload" />
    <edit-dialog ref="editDialog" @close-saved="reload" readonly  :show-save-button="showSaveButton" :DisposeTax="DisposeTax"/>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/purchase/business/predict/list";
import editDialog from "@/components/purchase/business/predict/editDialog";
import importDialog from "@/components/purchase/business/predict/importDialog";
export default {
  name: "receipt",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    importDialog,
  },
  data() {
    return {
      api: require("@/api/purchase/predict").default,
      optApi: require("@/api/sy/opt").default,
      showSaveButton: true,
      DisposeTax: "",
    };
  },
  mounted() {
    this.optApi.list({ Code: "PURCHASE" }).then((res) => {
      res.Data.forEach((e) => {
        if (e.OptText == "DisposeTax") {
          this.DisposeTax = e.OptValue;
        }
      });
    });
  },
  methods: {
    onImport() {
      this.$refs.importDialog.open();
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
    _edit(row){
      this.$refs.editDialog.changeShowSelectBtn(false);
      this.$refs.editDialog.setReadonly(true)
      this.showSaveButton = false;
      this.$refs.editDialog.openDetailsById(row.OrderId)
    },
    _create(){
      this.$refs.editDialog.changeShowSelectBtn(true);
       this.$refs.editDialog.setReadonly(false)
       this.showSaveButton = true;
       this.$refs.editDialog.openCreate()
    },
    // 一键生成采购单
    generatePurchaseOrder(row){
      this.api.generatePurchaseOrder(row.OrderId).then(res => {
        this.reload();
      })
    },
    del({OrderId}){
      this.$confirm("是否删除数据？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete({id: OrderId}).then(res => {
            this.$message({type: 'success', message: res.Msg})
            this.$refs.list.reload();
          })
        })
        .catch(() => {});
    }
  },
};
</script>